import { Plus } from 'lucide-react'
import { Tooltip } from '../ui/modal';
import { useTranslation } from 'react-i18next';

interface VideoTemplateAddButtonProps {
  showTooltip?: boolean;
  onSuccess?: () => void;
}

/*** 
 * 视频模板添加按钮
 * @param onSuccess 成功回调
 */
export const VideoTemplateAddButton: React.FC<VideoTemplateAddButtonProps> = ({
  showTooltip,
  onSuccess
}) => {
  const { t } = useTranslation();
  return (
    <>
      <Tooltip
        side='top'
        align='center'
        trigger={
          <div className='min-w-[52px] max-w-[52px] h-[70px] rounded-[8px] bg-[#f3f4f6]'>
            <button className='relative flex flex-col justify-center items-center gap-1 rounded-[10px] px-2.5 py-2 cursor-pointer min-w-[52px] max-w-[52px] h-[70px] bg-[#f3f4f6] hover:scale-110 transition-all'>
              <Plus className="size-5 text-[rgba(152,162,179,1)]" />
            </button>
          </div>
        }
        content={
          showTooltip && (
            <div className='relative bg-[rgba(16,24,40,1)] px-3 py-2 rounded-[8px]'>
              <span className='text-[rgba(255,255,255,1)] text-sm font-medium'>
                {t("agent_creation.subscription_settings.add_template")}
              </span>
              <div className="absolute top-full left-1/2 -translate-x-1/2 w-0 h-0 border-l-[6px] border-r-[6px] border-t-[6px] border-l-transparent border-r-transparent border-t-black"></div>
            </div>
          )
        }
      />
    </>
  )
}
